<script>
import { mapActions } from 'vuex';
import toggleModal from '@/mixins/toggleModal';

export default {
  data() {
    return {
      localPickUp: false,
    };
  },
  mixins: [toggleModal],
  methods: {
    ...mapActions({
      addZipCodesAction: 'zipCodes/addZipCodes',
    }),
    handleOk(values) {
      this.addZipCodesAction({ ...values, localPickUp: this.localPickUp });
      this.hideModal();
    },
  },
};
</script>

<template>
  <div>
    <a-modal open="show" :footer="null" @cancel="hideModal">
      <FormKit
        type="form"
        submit-label="Add zip code"
        @submit="handleOk"
      >
        <h1 class="text-2xl font-bold mb-2">Add postal code</h1>
        <FormKit
          type="text"
          name="zip"
          label="Zip code"
          placeholder="Zip code"
          validation="required"
        />
        <div class="toggle">
          Local pick up zone
          <a-switch class="mb-2" v-model:checked="localPickUp" />
        </div>
      </FormKit>
    </a-modal>
  </div>
</template>

<style scoped lang="scss">
  .toggle {
    margin: 20px 0;
  }
</style>
